<template>
  <div class="main-data" v-loading="loading">
    <el-row>
      <el-col :xs="24" :sm="20" :lg="12" :xl="14">
        <el-form ref="form" :model="form" :rules="rules" label-position="top">
          <el-row :gutter="10">
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
              <el-form-item label="Viloyat">
                <el-select
                    style="width: 100%"
                    size="large"
                    v-model="selectedRegion"
                    :disabled="$route.params.id && $store.state.role !== 'admin'"
                    @change="getDistricts"
                    :loading="regionsLoading"
                    placeholder="Malumot kiriting"
                >
                  <el-option
                      v-for="region in regions"
                      :key="region.id"
                      :value="region.id"
                      :label="region.title"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
              <el-form-item label="Tuman" prop="district_id">
                <el-select
                    style="width: 100%"
                    size="large"
                    :disabled="$route.params.id && $store.state.role !== 'admin'"
                    v-model="form.district_id"
                    :loading="districtsLoading"
                    placeholder="Malumot kiriting"
                >
                  <el-option
                      v-for="district in districts"
                      :key="district.id"
                      :value="district.id"
                      :label="district.title"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
              <el-form-item label="Mahalla nomi" prop="title">
                <el-input
                    size="large"
                    :disabled="$route.params.id && $store.state.role !== 'admin'"
                    class="form-input"
                    placeholder="Malumot kiriting"
                    v-model="form.title"
                    type="text"
                />
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
              <el-form-item label="Aholi soni" prop="citizen_count">
                <el-input
                    :disabled="$route.params.id && $store.state.role !== 'admin'"
                    size="large"
                    class="form-input"
                    placeholder="Malumot kiriting"
                    v-model="form.citizen_count"
                    type="number"
                />
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
              <el-form-item label="Soliq nomi va kodi" prop="id_number_id">
                <el-select
                    style="width: 100%"
                    size="large"
                    clearable
                    v-model="form.id_number_id"
                    filterable
                    placeholder="Malumot kiriting"
                >
                  <el-option
                      v-for="opt in id_numbers"
                      :key="opt.id"
                      :value="opt.id"
                      :label="opt.title + ' - ' + opt.id_number"
                      :class="{ is_available: !opt.is_available }"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
              <el-form-item label="Hisob raqami" prop="account_number_id">
                <el-select
                    style="width: 100%"
                    size="large"
                    clearable
                    placeholder="Malumot kiriting"
                    filterable
                    v-model="form.account_number_id"
                >
                  <el-option
                      v-for="account in account_numbers"
                      :key="account.id"
                      :value="account.id"
                      :label="account.acc_number"
                      :class="{ is_available: !account.is_available }"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
              <el-form-item label="Status" prop="status">
                <el-select
                    style="width: 100%"
                    size="large"
                    placeholder="Malumot kiriting"
                    filterable
                    v-model="form.status"
                    :disabled="$route.params.id && $store.state.role !== 'admin'"
                >
                  <el-option
                      v-for="stat in statuses"
                      :key="stat.id"
                      :value="stat.id"
                      :label="stat.title"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
              <el-form-item label="Moliyaviy holati" prop="status">
                <el-select
                    style="width: 100%"
                    size="large"
                    placeholder="Tanlang"
                    filterable
                    v-model="form.financial_status"
                >
                  <el-option
                      v-for="stat in financialStatuses"
                      :key="stat.value"
                      :value="stat.value"
                      :label="stat.label"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col
                :xs="24"
                :sm="24"
                :md="12"
                :lg="12"
                :xl="12"
                v-if="form.status === 'ARCHIVE' && $store.state.role === 'admin'"
            >
              <el-form-item
                  label="Qoshimcha mahalla nomi"
                  prop="additional_quarter_id"
              >
                <el-select
                    style="width: 100%"
                    size="large"
                    placeholder="Malumot kiriting"
                    filterable
                    v-model="form.additional_quarter_id"
                    :disabled="$route.params.id && $store.state.role !== 'admin'"
                >
                  <el-option
                      v-for="quarter in additionalQuartersList"
                      :key="quarter.id"
                      :value="quarter.id"
                      :label="quarter.title"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item>
                <el-button class="custom-btn" @click="() => this.$router.go(-1)"
                >Orqaga
                </el-button
                >
                <el-button class="custom-btn" type="primary" @click="onSubmit"
                >Saqlash
                </el-button
                >
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import {ElNotification} from "element-plus";

export default {
  name: "QuarterForm",
  watch: {
    "form.district_id": function () {
      this.getAccounts();
      this.getIDs();
    },
    "form.status": function () {
      if (
          !this.additionalQuartersList.length &&
          this.form.status == "ARCHIVE" &&
          this.$store.state.role == "admin"
      ) {
        this.getQuarterList();
      }

      if (this.form.status == "ACTIVE") {
        this.form.additional_quarter_id = null;
      }
    },
  },
  data() {
    return {
      loading: false,
      regionsLoading: false,
      districtsLoading: false,
      statuses: [
        {id: "ARCHIVE", title: "Arxiv"},
        {id: "ACTIVE", title: "Faol"},
      ],
      regions: [],
      districts: [],
      additionalQuartersList: [],
      id_numbers: [],
      account_numbers: [],
      selectedRegion: null,
      form: {
        id: null,
        status: null,
        title: null,
        district_id: null,
        citizen_count: null,
        account_number_id: null,
        id_number_id: null,
        additional_quarter_id: null,
        financial_status: 'GOOD'
      },
      financialStatuses: [
        {value: 'GOOD', label: "Yaxshi"},
        {value: 'BAD', label: "Og'ir"}
      ],
      rules: {
        title: [
          {required: true, message: "Majburiy maydon", trigger: "blur"},
        ],
        district_id: [
          {required: true, message: "Majburiy maydon", trigger: "change"},
        ],
        citizen_count: [
          {required: true, message: "Majburiy maydon", trigger: "blur"},
        ],
      },
    };
  },
  methods: {
    onSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.loading = true;

          let http;

          const formData = {
            ...this.form,
            id_number_id: this.form.id_number_id
                ? this.form.id_number_id
                : null,
            account_number_id: this.form.account_number_id
                ? this.form.account_number_id
                : null,
            additional_quarter_id: this.form.additional_quarter_id
                ? this.form.additional_quarter_id
                : null,
            citizen_count: parseInt(this.form.citizen_count, 10),
          };

          if (this.form.id) {
            http = this.$http.put(`/api/v1/quarters/${this.form.id}`, formData);
          } else {
            http = this.$http.post("/api/v1/quarters", formData);
          }

          http
              .then(() => {
                ElNotification({
                  title: "Tabriklaymiz",
                  message: "Muvafaqiyatli saqlandi",
                  type: "success",
                });
                this.$router.go(-1);
              })
              .catch(({response}) => {
                ElNotification({
                  title: "Xatolik",
                  message:
                      response.data.message || "Iltimos, qayta urinib ko'ring.",
                  type: "error",
                });
              })
              .finally(() => {
                this.loading = false;
              });
        }
      });
    },
    getIDs() {
      this.districtsLoading = true;
      this.$http
          .get("/api/v1/quarter-id-numbers/select", {
            params: {
              region_id: this.selectedRegion,
              district_id: this.form.district_id,
            },
          })
          .then(({data}) => {
            this.id_numbers = data.result;
          })
          .catch(() => {
          })
          .finally(() => {
            this.districtsLoading = false;
          });
    },
    getAccounts() {
      this.districtsLoading = true;
      this.$http
          .get("/api/v1/quarter-acc-numbers/select", {
            params: {
              region_id: this.selectedRegion,
              district_id: this.form.district_id,
            },
          })
          .then(({data}) => {
            this.account_numbers = data.result;
          })
          .catch(() => {
          })
          .finally(() => {
            this.districtsLoading = false;
          });
    },
    getQuarterList() {
      this.loading = true;
      this.$http
          .get("/api/v1/quarters")
          .then(({data}) => {
            this.additionalQuartersList = data.quarters;
          })
          .catch(({response}) => {
            ElNotification({
              type: "error",
              title: "Xatolik",
              message: response.data.message || "Yuklashda xatolik sodir bo'ldi",
            });
          })
          .finally(() => {
            this.loading = false;
          });
    },
    getRegions() {
      this.regionsLoading = true;
      this.$http
          .get("/api/v1/regions")
          .then(({data}) => {
            this.regions = data.regions;
          })
          .catch(() => {
          })
          .finally(() => {
            this.regionsLoading = false;
          });
    },
    getDistricts() {
      this.districtsLoading = true;
      this.$http
          .get("/api/v1/districts", {
            params: {
              region_id: this.selectedRegion,
            },
          })
          .then(({data}) => {
            this.districts = data.districts;
          })
          .catch(() => {
          })
          .finally(() => {
            this.districtsLoading = false;
          });
    },
    getQuarter(id) {
      this.loading = true;
      this.$http
          .get(`/api/v1/quarters/${id}`)
          .then(({data}) => {
            this.form = data;
            this.getDistrict(this.form.district_id);
          })
          .catch(({response}) => {
            ElNotification({
              type: "error",
              title: "Xatolik",
              message: response.data.message || "Yuklashda xatolik sodir bo'ldi",
            });
          })
          .finally(() => {
            this.loading = false;
          });
    },
    getDistrict(id) {
      this.loading = true;
      this.$http
          .get(`/api/v1/districts/${id}`)
          .then(({data}) => {
            this.districts.push(data);
            this.selectedRegion = data.region_id;
            this.getDistricts();
          })
          .catch(({response}) => {
            ElNotification({
              type: "error",
              title: "Xatolik",
              message: response.data.message || "Yuklashda xatolik sodir bo'ldi",
            });
          })
          .finally(() => {
            this.loading = false;
          });
    },
  },
  mounted() {
    if (this.$route.params.id) {
      this.getQuarter(this.$route.params.id);
    }

    if (this.$store.state.role !== "admin" && !this.$route.params.id) {
      this.$router.go(-1);
    }

    this.getRegions();
  },
};
</script>

<style scoped>
.is_available {
  display: none;
}
</style>
